module.exports = __webpack_public_path__ + "static/media/appBanner.ebf4f88e.png";